import React from 'react'
import styled from 'styled-components'
import { Title, Subtitle, ContainerFlexColumn } from './Utils/CustomClasses'

const WhatsIncluded = styled(ContainerFlexColumn)``

const WhatsIncludedTable = styled.table`
  border-spacing: 2px;
  border-collapse: separate;
  width: 100%;
  margin: 0 auto;

  tr:last-child {
    td:first-child {
      border-radius: 0 0 0 5px;
    }
    td:last-child {
      border-radius: 0 0 5px 0;
    }
  }
`

const WitHL = styled.th`
  background-color: #3d8394;
  border-radius: 5px 0 0 0;
  color: #fff;
  padding: 13px 13px 13px 25px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
`

const WitHR = styled(WitHL)`
  border-radius: 0 5px 0 0;
  text-align: center;
  padding: 13px;
`

const WitL = styled.td`
  background-color: #4ea2b6;
  color: #fff;
  padding: 13px 13px 13px 25px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 16px;
`

const WitR = styled(WitL)`
  text-align: center;
  padding: 13px;

  img {
    width: 20px;
  }
`
const WhatsIncludedPanel = ({}) => {
  return (
    <WhatsIncluded center>
      <Title
        color="#154549"
        size="30px"
        sizemd="1.6rem"
        sizesm="30px"
        center
        margin="0 10vw 24px 10vw"
        marginmd="0 10vw 24px 10vw"
        marginsm="20px 0 24px 0"
        dangerouslySetInnerHTML={{
          __html: `What's included`,
        }}
      ></Title>
      <Subtitle
        center
        weight="300"
        color="#154549"
        size="22px"
        sizemd="22px"
        sizesm="22px"
        margin="0 0 50px 0"
        marginsm="0 8px 40px 8px"
        dangerouslySetInnerHTML={{
          __html: `Your Freebird membership includes access to our secure and exclusive members-only community of like-minded senior travellers, homestay hosts, travel buddies and local experts.`,
        }}
      />
      <WhatsIncludedTable>
        <thead>
          {' '}
          <WitHL>Feature</WitHL>
          <WitHR>Included?</WitHR>
        </thead>
        <tbody>
          <tr>
            <WitL>Safe and secure platform</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>All members are verified</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Plan trips with the help of local experts</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Book friendly homestays</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Arrange meet-ups in destinations</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Find travel buddies</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Become a homestay host</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Search for like-minded members</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Attend members-only events with fellow Freebirds</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Make new friends in our community portal</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Share travel experiences</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Participate in competitions and challenges</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
          <tr>
            <WitL>Join community discussion groups</WitL>
            <WitR>
              <img src={'/images/icons/tick-sm.svg'} />
            </WitR>
          </tr>
        </tbody>
      </WhatsIncludedTable>
    </WhatsIncluded>
  )
}
export default WhatsIncludedPanel
